import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=7768c6d2&scoped=true&"
import script from "./PlanInfo.vue?vue&type=script&lang=js&"
export * from "./PlanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7768c6d2",
  null
  
)

export default component.exports